import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link } from '@remix-run/react';
import { cn } from '@theprintbar/shared';
import { ReactNode } from 'react';

interface PageContainerProps {
	title: ReactNode;
	limitWidth?: boolean | string;
	back?: { to: string; label: string };
	children?: React.ReactNode;
	className?: string;
	variant?: 'outline' | 'primary';
	subtitle?: ReactNode;
	actions?: ReactNode;
}

export function PageContainer({
	title,
	limitWidth,
	back,
	children,
	actions,
	subtitle,
	className,
	variant = 'primary',
}: PageContainerProps) {
	return (
		<div
			className={cn(
				'flex flex-col w-full  p-4 lg:p-8 mx-auto',
				limitWidth && (typeof limitWidth === 'string' ? limitWidth : 'max-w-7xl'),
				className,
			)}
		>
			<div className="flex lg:h-6 items-center mb-2 lg:mb-4">
				{!!back && (
					<Link to={back.to} className="flex items-center text-grey text-xs">
						<ArrowLeftIcon className="h-3 w-3 lg:h-4 lg:w-4 mr-1" />
						{back.label}
					</Link>
				)}
			</div>

			<div
				className={cn(
					'mb-4 lg:mb-8 flex flex-wrap gap-4 justify-between items-start',
					variant === 'outline' && 'bg-white p-7 text-blue border border-blue rounded-3xl',
				)}
			>
				<div className={cn(variant === 'outline' && 'space-y-1')}>
					<h1 className="text-2xl lg:text-3xl font-display font-light tracking-tight text-blue">{title}</h1>
					<p className="text-xs lg:text-sm text-grey max-w-xl">{subtitle}</p>
				</div>
				{actions}
			</div>
			{children}
		</div>
	);
}
